import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getTicketRequestDetail } from '../api/ticketRequestApi'

/**
 * Tek talebin detayını çeker (salt-okuma). Dil değişince ad'lar için yeniden çeker. `id` geçersizse
 * (null) sorgu devre dışı. 404 (yok/silinmiş) beklenen bir sonuçtur ve terminaldir → `retry: false`
 * ile hemen hataya düşer (aksi halde prod QueryClient varsayılan 3 retry + backoff ile spinner uzar
 * ve gereksiz istek atılır). Sayfa hatayı "bulunamadı" olarak ele alır.
 */
export function useTicketRequestDetail(
  id: number | null,
  exactPnr?: string,
  exactName?: string,
) {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['ticket-request-detail', i18n.language, id, exactPnr ?? '', exactName ?? ''],
    queryFn: () => getTicketRequestDetail(id as number, exactPnr, exactName),
    enabled: id != null,
    retry: false,
  })
}
